import { render, staticRenderFns } from "./counter-chip.vue?vue&type=template&id=496fb2f5&"
import script from "./counter-chip.vue?vue&type=script&lang=js&"
export * from "./counter-chip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports